import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_BILL_INSTITUTION_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  BillingInstitutions,
  GetBillingInstitutionsPayload,
  GetBillingInstitutionsResult,
} from '../types/getBillingInstitutions.types';

export const getBillingInstitutions = (builder: BuilderType) =>
  builder.query<BillingInstitutions[], GetBillingInstitutionsPayload>({
    providesTags: ['BillingInstitutions'],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PAYMENTS_BILL_INSTITUTION_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetBillingInstitutionsResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.BillingInstitutions;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
